/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Action_DeductInputs */

const en_admin_users_credits_action_deduct = /** @type {(inputs: Admin_Users_Credits_Action_DeductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deduct`)
};

const zh_admin_users_credits_action_deduct = /** @type {(inputs: Admin_Users_Credits_Action_DeductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扣除`)
};

/**
* | output |
* | --- |
* | "Deduct" |
*
* @param {Admin_Users_Credits_Action_DeductInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_action_deduct = /** @type {((inputs?: Admin_Users_Credits_Action_DeductInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Action_DeductInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_action_deduct(inputs)
	return zh_admin_users_credits_action_deduct(inputs)
});
export { admin_users_credits_action_deduct as "admin.users.credits_action_deduct" }